import { render } from "./SnehaSparshamApplicationEdit.vue?vue&type=template&id=04ea4cb2&scoped=true"
import script from "./SnehaSparshamApplicationEdit.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplicationEdit.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplicationEdit.vue?vue&type=style&index=0&id=04ea4cb2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ea4cb2"]])

export default __exports__